/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          key: {
            type: 'string',
            enum: [
              'CHILDCARE_FACILITIES_ARE_ON_THE_GROUND_FLOOR',
              'CHILDCARE_FACILITIES_ARE_KEPT_CLEAN_SAFE_AND_HYGIENIC_INCLUDING',
              'CHILDCARE_FACILITIES_ARE_PROVIDED_WITH_ADEQUATE_SUPPLIES_AND_IN',
              'CHILDCARE_STAFF_GO_THROUGH_AN_APPROPRIATE_PRE_WORK_SCREENING_PR',
              'CHILDCARE_STAFF_ARE_PRESENT_IN_SUFFICIENT_NUMBERS_TO_ENSURE_THE',
              'CAPACITY_OF_THE_CHILDCARE_FACILITY_IS_SUFFICIENT_TO_COVER_THE_N',
              'A_SYSTEM_IS_IN_PLACE_TO_ENSURE_THAT_CHILDREN_ARE_ONLY_RELEASED_',
              'NONE_OF_THE_ABOVE',
            ],
          },
          isChecked: {
            type: 'boolean',
          },
          followUp: {
            type: ['object', 'null'],
            properties: {
              value: {
                type: 'string',
              },
            },
            required: ['value'],
          },
        },
        required: ['key', 'isChecked', 'followUp'],
      },
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    does_the_fac_have_any_of_the_following_measures_in_place_regard: valueSchema,
  },
}
